import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Text, Button } from "@mantine/core";
import { useIntl } from "react-intl";
import TermsAndConditionsModal from "../components/TermsAndConditionsModal";
import { useMediaQuery } from "@mantine/hooks";

function Footer() {
  const intl = useIntl();
  const navigate = useNavigate();
  const smallSize = useMediaQuery("(max-width: 470px)");

  const [termsAndConditionsModalOpen, setTermsAndConditionsModalOpen] =
    useState(false);

  const onContactUsButtonClick = () => {
    const subject = encodeURIComponent("Inquiry from Soft Retired website");
    window.location.href = `mailto:contact@softretired.com?subject=${subject}`;
  };

  // const onCompanyButtonClick = () => {
  //   navigate("/company");
  // };

  const onTermsAndConditionsButtonClick = () => {
    setTermsAndConditionsModalOpen(true);
  };

  const handleOnCloseTermsAndCondModal = () => {
    setTermsAndConditionsModalOpen(false);
  };

  const onAboutButtonClick = () => {
    navigate("/about");
  };

  const termsAndConditionsModal = termsAndConditionsModalOpen ? (
    <TermsAndConditionsModal
      opened={termsAndConditionsModalOpen}
      onClose={handleOnCloseTermsAndCondModal}
    />
  ) : null;

  return (
    <>
      {termsAndConditionsModal}
      <div className="footer">
        <footer className="footer-content">
          <Text
            size="xs"
            c="gray"
            style={smallSize ? { maxWidth: "140px" } : {}}
          >
            Copyright © 2025 SoftRetired Solutions Ltd.
          </Text>
          <Button variant="subtle" color="gray" onClick={onAboutButtonClick}>
            {intl.formatMessage({ id: "header.about" })}
          </Button>
          <Button
            variant="subtle"
            color="gray"
            onClick={onContactUsButtonClick}
          >
            {intl.formatMessage({ id: "button.contactUs" })}
          </Button>
          {/* <Button variant="subtle" color="gray" onClick={onCompanyButtonClick}>
          {intl.formatMessage({ id: "button.company" })}
        </Button> */}
          {/* <Button
            variant="subtle"
            color="gray"
            onClick={onTermsAndConditionsButtonClick}
          >
            {intl.formatMessage({ id: "signup.termsAndConditions" })}
          </Button> */}
        </footer>
      </div>
    </>
  );
}

export default Footer;
